import React, { Suspense } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import { ProfileCardLazy } from '@atlaskit/profilecard/user';
import Skeleton from '@atlaskit/skeleton';

import type { PeopleOutput } from '../types';

export const PeopleProfileCard = ({ data }: { data: PeopleOutput }) => {
	return (
		<Stack space="space.100">
			{data.people.map((person, idx) => (
				<Suspense key={idx} fallback={<Skeleton width="260px" height="360px" />}>
					<ProfileCardLazy
						userId={person.accountId}
						avatarUrl={person?.profile?.picture}
						fullName={person?.profile?.name}
						location={person?.profile?.location}
						email={person?.profile?.email}
						timestring={person?.profile?.timezone}
						meta={person?.profile?.jobTitle}
						companyName={person?.profile?.organization}
					/>
				</Suspense>
			))}
		</Stack>
	);
};
